import React, { Component } from 'react';
import './newHeader.scss'
import { Tooltip, Modal, Button, Input, Select, message  } from 'antd';
import {store} from 'Store/store.index';
import { inject, observer } from 'mobx-react';
import { shareWXACode } from '@/api/fwApi/webpdfapi';
const { Option } = Select
@inject('userNewStore', 'common')
@observer
class share extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docId: "", // ! 上传文档的Id
      fileName: "",
      isShowDialog: false,
      realNameDialog: false,
      sharePageDialog: false,
      addPasswordDialog: false,
      createdShareDialog: false,
      realNameSuccessDialog: false,
      phoneNumber: "", // 手机号
      errText: "", // 错误提示
      getCode: false,
      getKeyText: "获取验证码",
      code: "",
      setBind: false,
      activeDays: 7,
      checkRadioValue: "public",
      password: "",
      addPasswordErr: ""
    };
  }
  getDocsInfo = () => {
    // 获取云文档token
    store.common.setIsShowMeeting(true) 
    store.docsStore.getToken().then(res => {
      // !获取token = res.data.token
      if(res.code === 0) {
        // 获取云文档更目录
        store.docsStore.getRootFolder().then(resFolder => {
          // !获取根目录id: folderId = res.data.folderId
          if(resFolder.code === 0){
            if(store.saveFileNewStore.isSaveSuccess) {
              store.appStore.doUpdateDocModified(false, true)
              store.saveFileNewStore.setIsSaveSuccess(false)
            }
            let docsFolderId = resFolder.data.folderId
            this.saveCurrentFile(docsFolderId)
          }
        }).catch(() => {
          store.common.setIsShowMeeting(false) 
        })
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  saveCurrentFile = async (folderId) => {
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    let fileName = pdfDoc.info.fileName
    store.docsStore.fileToBlob(fileName, folderId, false).then(res => {
      // res.code = 40003
      if (res.code === 0) {
        // !保存文件id
        store.common.setIsShowMeeting(false) 
        let data = res.data
        store.shareStore.setShareDocId(res.data.docId)
        this.setState({
          fileName: data.fileName,
          createdShareDialog: true
        })
      } else if (res.code === 40002) {
        //40002 文件名重名 添加时间戳
        let time = store.docsStore.formatCompleteTime(new Date());
        let fileNamePrefix = fileName.substring(
          0,
          fileName.lastIndexOf(".")
        );
        fileName = `${fileNamePrefix}_${time}.pdf`
        store.docsStore.fileToBlob(fileName, folderId)
      } else if (res.code === 40003) {
        // 1004 空间不足
        store.common.setIsShowMeeting(false) 
        store.docsStore.lackOfSpace();
      } else {
        store.common.setIsShowMeeting(false) 
      }
      store.common.setIsShowMeeting(false) 
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  // 点击分享
  shareClick = () => {
    // 判断是否可点击
    // 判断userId
    // if(isMac && !store.docStore.macToDocPage) {
    //   store.docsStore.showMacDocs = true;
    //   return
    // }
    if(store.shareStore.shareDisabled || !store.userNewStore.userData.userId) {
      return
    }
    // 重新判断是否会员, res为identity
    store.userNewStore.checkVip().then(() => {
      if(store.viewer.hasOpenFile) {
        // 判断是否实名认证：是=>下一步；否=>弹出实名窗口
        // if(store.userNewStore.realName) {
        //   if (store.shareStore.isShare) { // 该文件是否已经上传云文档
        //     // ! 已上传， 打开分享详情弹窗
        //     this.setState({
        //       sharePageDialog: true
        //     })
        //   } else {
        //     // 保存已上传文件的docId，如果已经上传：显示创建分享弹窗
        //     if (store.shareStore.shareDocId) {
              
        //       this.setState({
        //         createdShareDialog: true
        //       })
        //     } else { // 未上传，则上传文件
        //       this.getDocsInfo()
        //     }
        //   }
        // } else {
          // IAM 实名判断方式 改为使用userDate中phoneVerified接口
          if (store.loginNewStore.IAMToken) {
            if (store.userNewStore.userData.phoneVerified) { // 已实名
              if (store.shareStore.isShare) { // 该文件是否已经上传云文档
                // ! 已上传， 打开分享详情弹窗
                this.setState({
                  sharePageDialog: true
                })
              } else {
                // 已经上传文件
                if (store.shareStore.shareDocId) {
                  this.setState({
                    createdShareDialog: true
                  })
                } else {
                  this.getDocsInfo()
                }
              }
            } else {
              // 未实名跳转到iam实名页面
              message.warning('该账户未实名，请绑定手机');
              setTimeout(() => {
                window.open("https://account.foxitreader.cn/usercenter/")
              }, 2000)
            }
            return
          }
          // 非IAM SSO的流程（保留）
          store.userNewStore.isRealName().then(real =>{ //isRealName的接口需要jsonp
            if(real.ret === 1019 || real.ret === 1004) { //! 已实名
              if (store.shareStore.isShare) { // 该文件是否已经上传云文档
                // ! 已上传， 打开分享详情弹窗
                this.setState({
                  sharePageDialog: true
                })
              } else {
                // 已经上传文件
                if (store.shareStore.shareDocId) {
                  this.setState({
                    createdShareDialog: true
                  })
                } else {
                  this.getDocsInfo()
                }
              }
            } else { //! 未实名
              // 弹出实名窗口
              this.setState({
                realNameDialog: true
              })
            }
          }).catch(err => {
            console.log(err)
          })
        // }
      } else {
        this.setState( {isShowNoPdfModal: true})
        return
      }
    })
  }
  changeTel = (e) => {
    this.setState({
      phoneNumber: e.target.value
    })
  }
  changeCode = (e) => {
    this.setState({
      code: e.target.value
    })
  }
  getKey = () => {
    // 获取验证码
    if(this.state.getCode) {
      return
    }
    let tel = this.state.phoneNumber
    let mobile = /^1[3456789]\d{9}$/;
    if (!tel) {
      this.setState({
        errText: "请填写手机号码"
      })
      return
    } else if (!/^\d{11}$/.test(tel) || !mobile.test(tel)) {
      this.setState({
        errText: "请填写正确的手机号码"
      })
      return
    }
    store.userNewStore.isRealName(tel).then(res => {
      if(res.ret === 0) {
        this.setState({
          getCode: true,
          errText: ''
        })
        this.countDown()
      } else {
        this.setState({
          getCode: true
        })
        this.countDown()
        this.setState({
          errText: res.msg
        })
        return
      }
      
    })
  }
  setBindTel = () => {
    if(this.state.setBind) {
      return
    }
    let code = this.state.code
    let tel = this.state.phoneNumber
    let mobile = /^1[3456789]\d{9}$/;
    if (tel === "") {
      this.setState({
        errText: "请填写手机号码"
      })
      return
    } else if (!/^\d{11}$/.test(tel) || !mobile.test(tel)) {
      this.setState({
        errText: "请填写正确的手机号码"
      })
      return
    }
    if (code === "") {
      this.setState({
        errText: "请填写验证码"
      })
      return
    }
    this.setState({
      setBind: true
    })
    store.userNewStore.setBindTel(tel, code).then(res => {
      if(res.ret === 0) {
        this.setState({
          code: "",
          phoneNumber: "",
          realNameDialog: false,
          realNameSuccessDialog: true,
          setBind: false,
          errText: ""
        })
        store.userNewStore.setRealName(true)
        setTimeout(() => {
          this.setState({
            realNameSuccessDialog: false,
          })
        }, 2000)
      } else {
        this.setState({
          errText: res.msg,
          setBind: false
        })
      }
    }).catch(err => {
      this.setState({
        errText: err.msg || "",
        setBind: false
      })
    })
  } 
  copyThis = () => {
    // 复制文本到剪切板
    const shareDocsInfo = store.shareStore.shareDocsInfo
    let copyThis = ""
    if(shareDocsInfo.drawCode) {
      copyThis = `【 链接：${shareDocsInfo.shareUrl} 密码：${shareDocsInfo.drawCode}】`
    } else {
      copyThis = `【 链接：${shareDocsInfo.shareUrl} 】`
    }
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', copyThis);
    input.select();
    if (document.execCommand('copy')) {
        document.execCommand('copy');
        console.log('复制成功');
        message.success('复制成功');
    }
    document.body.removeChild(input);
  }
  downloadQRcode = () => {
    // 获取文件流
    let url = store.shareStore.shareDocsInfo.codeImgUrl
    if (window.navigator.msSaveBlob) {
      var blob = store.shareStore.base64ToBlob(url);
      window.navigator.msSaveBlob(blob, "二维码.png")
    } else {
      // 下载本地成功
      let a = document.createElement('a');          // 创建一个a节点插入的document
      let event = new MouseEvent('click')           // 模拟鼠标click点击事件
      a.download = '二维码'                  // 设置a节点的download属性值
      a.href = url;                                 // 将图片的src赋值给a节点的href
      a.dispatchEvent(event)                        // 触发鼠标点击事件
      if (!(navigator.userAgent.indexOf('Safari') > -1)) {
          window.URL.revokeObjectURL(a.href)
      }
    }
  }
  createdAndShare = () => {
    // 创建并分享, 1、判断isEncrypted--是否加密；2、调用createShare接口
    let params = {}
    params.isEncrypted = this.state.checkRadioValue === "public"? false : true
    params.docId = store.shareStore.shareDocId
    params.activeDays = this.state.activeDays
    params.owner = store.userNewStore.userData.nickname
    params.avatar = store.userNewStore.userData.figure
    store.docsStore.createShare(params).then(res => {
      if (res) {
        // store.shareStore保存当前文档的share信息，用于展示
        if (res.data.drawCode) {
          res.data.isEncrypted = true;
          this.setState({
            password: res.data.drawCode
          })
        } else {
          res.data.isEncrypted = false;
          this.setState({
            password: ""
          })
        }
        store.shareStore.setIsShare(true)
        this.setShareOption(res.data);
        // 小程序二维码
        // this.getUnlimited(res.data.id, (imageUrl) => {
        //   // res.data.codeImgUrl = imageUrl.substr(1).substr(0, imageUrl.substr(1).length - 1);;
        //   res.data.codeImgUrl = imageUrl.substr(0, imageUrl.substr(1).length - 1);
        //   this.setShareOption(res.data);
        // })
        // 成功 应该显示信息 对应操作
        this.setState({
          createdShareDialog: false,
          sharePageDialog: true
        })
      } else {
        this.setState({
          createdShareDialog: true,
          sharePageDialog: false
        })
      }
    })
  }
  setShareOption = (data) => {
    store.shareStore.setShareDocsInfo(data)
  }
  cancelShare = () => {
    store.docsStore.cancelShare(store.shareStore.shareDocsInfo.shareId).then(res => {
      if(res.code === 0) {
        store.shareStore.setIsShare(false)
        store.shareStore.shareDocsInfo = {}
        this.setState({
          sharePageDialog: false,
          createdShareDialog: true
        })
      }
    })
  }
  // 获取小程序二维码
  getUnlimited = (shareId, callback) => {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
    }
    const params = {
      shareId
    }
    shareWXACode(params, config).then(res => {
      callback(res)
    })
  }
  showAddPassword = () => {
    this.setState({
      addPasswordDialog:true
    })
  }
  changePassword = (e) => {
    this.setState({
      password: e.target.value
    })
  }
  savePassword = () => {
    this.setState({
      addPasswordErr: ""
    })
    let info = store.shareStore.shareDocsInfo
    if(info.drawCode === this.state.password) {
      this.setState({
        addPasswordDialog: false
      })
      return
    }
    if(!this.state.password) {
      this.setState({
        addPasswordErr: "密码不能为空"
      })
      return
    }
    info.drawCode = this.state.password
    info.isEncrypted = true
    store.shareStore.setShareDocsInfo(info, true).then(res => {
      this.setState({
        password: res.data.drawCode,
        addPasswordDialog: false,
        addPasswordErr: ""
      })
    })
  }
  changeActiveDay = (e) => {
    let info = store.shareStore.shareDocsInfo
    info.activeDays = e
    store.shareStore.setShareDocsInfo(info, true).then(res => {
      console.log(res)
    })
  }
  checkRadio = (e) => {
    console.log(e)
    this.setState({
      checkRadioValue: e
    })
  }
  countDown() {
    let num = 60
    let countDown = setInterval(() => {
      num--;
      if(num == 0) {
        this.setState({
          getCode: false,
          getKeyText: "获取验证码"
        })
        clearInterval(countDown)
        return
      }
      this.setState({
        getKeyText: `重试(${num})`
      })
    }, 1000)
  }
  render() {
    const { realNameDialog, sharePageDialog, addPasswordDialog, createdShareDialog, errText, getKeyText, realNameSuccessDialog, fileName, checkRadioValue, password, addPasswordErr } = this.state
    const { shareDisabled, shareDocsInfo } = store.shareStore
    const maxCode = 6
    const maxPassword = 4
    return (
      <div className='share-btn-box'>
        <Tooltip placement="bottom" title={"分享"}>
          <i className={`share-btn icon-btn cursor-pointer ${shareDisabled&&"shareDisabled"}`} onClick={this.shareClick} />
        </Tooltip>
        { realNameDialog && <Modal
            width={362}
            closable = { true }
            title=""
            visible = { realNameDialog }
            className = "noPdf shareBox"
            footer = {[
              <Button key="submit" type="primary" onClick={this.setBindTel}>立即绑定</Button>
            ]}
            onCancel= {() => {this.setState({realNameDialog:false})}}
          >
            <div>
              <img  src={require('../../assets/fw_cloud_editor/main/bindPhone.png')} alt="提示" />
              <p>
                绑定手机，开启登录两步验证，账号更安全。
              </p>
            </div>
            <div className="realNameForm">
              <Input placeholder="请输入手机号码" onChange={(e) => this.changeTel(e)} ></Input>
              <div className="getKeyBox">
                <Input placeholder="请输入验证码" maxLength={maxCode} onChange={(e) => this.changeCode(e)} /><Button key="getKey" onClick={this.getKey}>{ getKeyText }</Button>
              </div>
              <p className="errText">{ errText || "" }</p>
            </div>
          </Modal>
        }
        { 
          realNameSuccessDialog && <Modal
            width={362}
            closable = { true }
            title=""
            visible = { realNameSuccessDialog }
            className = "noPdf bindSuccerBox"
            footer = {null}
            onCancel= {() => {this.setState({realNameSuccessDialog:false})}}
          >
            <div>
              <img  src={require('../../assets/fw_cloud_editor/main/bindSuccess.png')} alt="成功" />
              <p>
                账号绑定成功!
              </p>
            </div>
          </Modal>
        }
        {/* 分享信息页面 */}
        { sharePageDialog && <Modal
            width={450}
            closable = { true }
            title={ fileName || "福昕云编辑" }
            visible = { sharePageDialog }
            className = "noPdf shareBox dialogTitle"
            footer = {null}
            onCancel= {() => {this.setState({sharePageDialog:false})}}
          >
            <div className="sharePageDialog">
              <div className="sharePageDialogLeft">
                <p>分享链接</p>
                <div className="copyBox">
                  {/* <Input disabled defaultValue={shareDocsInfo.shareUrl} className={`${shareDocsInfo.drawCode&&"showPasswordSpan"}`}/> */}
                  <span className={`ant-input ant-input-disabled ${shareDocsInfo.drawCode?"showPasswordSpan":"showNoPassSpan"}`}>{shareDocsInfo.shareUrl}</span>
                  {shareDocsInfo.drawCode && <span className="showPasswordInCopyForShare">密码: {shareDocsInfo.drawCode}</span> }
                  <Button key="copyBtn" type="primary" onClick={this.copyThis}>复制</Button>
                </div>
                <p className="passwordBox" onClick={this.showAddPassword}>
                  <i className="iconPassword"></i>
                  {shareDocsInfo.drawCode ? "修改密码" : "添加密码"}
                </p>
                <div className="leftBottom">
                  <div className="selectBox">
                    <label>有效期</label>
                    <Select value={shareDocsInfo.activeDays} onChange={(e) => {this.changeActiveDay(e)}}>
                      <Option value={1}>1天</Option>
                      <Option value={7}>7天</Option>
                      <Option value={30}>30天</Option>
                      <Option value={0}>永久</Option>
                    </Select>
                  </div>
                  <Button key="resetShare" onClick={this.cancelShare}>取消分享</Button>
                </div>
              </div>
              {/* <div className="realNameForm">
                <div>
                  <img src={shareDocsInfo.codeImgUrl}></img>
                  <p>将二维码分享给好友，</p>
                  <p>对方微信扫一扫即可获取文件</p>
                </div>
                <Button key="submit" type="primary" onClick={this.downloadQRcode}>下载二维码</Button>
                <p className="passwordText">已含密码，扫码后无需再次输入</p>
              </div> */}
            </div>
          </Modal>
        }
        {/* 添加密码弹窗 */}
        { 
          addPasswordDialog && <Modal
            width={450}
            closable = { true }
            title={ fileName || "福昕云编辑" }
            visible = { addPasswordDialog }
            className = "noPdf addPasswordDialog dialogTitle"
            footer={[
              <Button key="addPasswordCancel" onClick={() => {this.setState({addPasswordDialog:false})}}>取消</Button>,
              <Button key="addPasswordsubmit" type="primary" onClick={this.savePassword}>保存</Button>
            ]}
            onCancel= {() => {this.setState({addPasswordDialog:false})}}
          >
            <div>
              <p>请输入密码</p>
              <Input placeholder="请输入4位新密码，限数字与字母" maxLength={maxPassword} type="text" value={password} onChange={(e) => {this.changePassword(e)}}></Input>
              <p>{addPasswordErr}</p>
            </div>
          </Modal>
        }
        {/* 创建分享页 */}
        { 
          createdShareDialog && <Modal
            width={450}
            destroyOnClose = { true }
            closable = { true }
            title={ fileName || "福昕云编辑" }
            visible = { createdShareDialog }
            className = "noPdf createdShareDialog dialogTitle"
            footer={[
              <Button key="submit" onClick={() => {this.setState({createdShareDialog:false})}}>取消</Button>,
              <Button key="submitCreated" type="primary" onClick={this.createdAndShare}>创建并分享</Button>
            ]}
            onCancel= {() => {this.setState({createdShareDialog:false})}}
          >
            <div>
              <p>分享链接权限</p>
              <ul>
                <li className={`shareLi ${checkRadioValue==="public"&&"active"}`} onClick={() => {this.checkRadio("public")}} >
                  <img src={require("../../assets/fw_cloud_editor/main/overt.png")}></img>
                  <div>
                    <p>公开分享</p>
                    <p>适用于文件公开分享，仅限查看</p>
                  </div>
                  <input className="shareRadio" type="radio" name="type" value="public" checked={checkRadioValue==="public"} onChange={() => {}}/>
                </li>
                <li className={`shareLi ${checkRadioValue==="private"&&"active"}`}  onClick={() => {this.checkRadio("private")}} >
                  <img src={require("../../assets/fw_cloud_editor/main/encryption.png")} alt="加密分享"></img>
                  <div>
                    <p>加密分享</p>
                    <p>适用于隐私文件，访问时需输入密码，仅限查看</p>
                  </div>
                  <input className="shareRadio" type="radio" name="type" value="private" checked={checkRadioValue==="private"} onChange={() => {}}/>
                </li>
              </ul>
            </div>
          </Modal>
        }
      </div>
    )
  }
}
export default share;
